// extracted by mini-css-extract-plugin
export default {"root":"Callout_root__0lt-T","content":"Callout_content__iIqdT","icon":"Callout_icon__ai5b8"};